// extracted by mini-css-extract-plugin
module.exports = {"contact":"_110"};